import React, { useState, useEffect, useContext } from "react";
import Input from "../UI/Input";
import styles from "./AddressDetails.module.css";
import AppContext from "../../store/app-context";

const AddressDetails = (props) => {
  const appCtx = useContext(AppContext);
  const [states, setStates] = useState();

  let stateJSON = [];

  if(appCtx && states){
    const locale = appCtx.lang + "_" + appCtx.country;
    stateJSON = states[locale];
  }

  let label_company = 'Company Name';
  let label_attention = 'Attention';
  let label_address1 = 'Address 1';
  let label_address2 = 'Address 2';
  let label_suite = 'Suite';
  let label_building = 'Building';
  let label_room = 'Room';
  let label_floor = 'Floor';
  let label_cityTown = 'City/Town';
  let label_state = 'State/Province';
  let label_zip = 'Zip Code';
  let label_phNumber = 'Phone Number';
  let label_phExt = 'Ext';
  let label_companyRequired = 'Company name is required.';
  let label_addressRequired = 'Address is required.';
  let label_cityTownRequired = 'City/Town is required.';
  let label_stateRequired = 'State is required.';
  let label_zipRequired = 'Zip/Postal code is required.';
  let label_phoneRequired = 'Phone number is required.';

  if(appCtx && appCtx.bioradResources){
    label_company = appCtx.bioradResources.Company_Institution_Name ? appCtx.bioradResources.Company_Institution_Name : 'Company Name';
    label_attention = appCtx.bioradResources.Attention ? appCtx.bioradResources.Attention : 'Attention';
    label_address1 = appCtx.bioradResources.Address1 ? appCtx.bioradResources.Address1 : 'Address 1';
    label_address2 = appCtx.bioradResources.Address2 ? appCtx.bioradResources.Address2 : 'Address 2';
    label_suite = appCtx.bioradResources.Suite ? appCtx.bioradResources.Suite : 'Suite';
    label_building = appCtx.bioradResources.Building ? appCtx.bioradResources.Building : 'Building';
    label_room = appCtx.bioradResources.Room ? appCtx.bioradResources.Room : 'Room';
    label_floor = appCtx.bioradResources.Floor ? appCtx.bioradResources.Floor : 'Floor';
    label_cityTown = appCtx.bioradResources.City_Town ? appCtx.bioradResources.City_Town : 'City/Town';
    label_state = appCtx.bioradResources.State ? appCtx.bioradResources.State : 'State/Province';
    label_zip = appCtx.bioradResources.Postal_Code ? appCtx.bioradResources.Postal_Code : 'Zip Code';
    label_phNumber = appCtx.bioradResources.Phone_Number ? appCtx.bioradResources.Phone_Number : 'Phone Number';
    label_phExt = appCtx.bioradResources.Extn ? appCtx.bioradResources.Extn : 'Ext';
    label_companyRequired = appCtx.bioradResources.Customer_Company_Required ? appCtx.bioradResources.Customer_Company_Required : 'Company name is required.';
    label_addressRequired = appCtx.bioradResources.Address_Required ? appCtx.bioradResources.Address_Required : 'Address is required.';
    label_cityTownRequired = appCtx.bioradResources.CityTown_Required ? appCtx.bioradResources.CityTown_Required : 'City/Town is required.';
    label_stateRequired = appCtx.bioradResources.State_Required ? appCtx.bioradResources.State_Required : 'State is required.';
    label_zipRequired = appCtx.bioradResources.Zip_Required ? appCtx.bioradResources.Zip_Required : 'Zip/Postal code is required.';
    label_phoneRequired = appCtx.bioradResources.Phone_Required ? appCtx.bioradResources.Phone_Required : 'Phone number is required.';
  }

  const [company, setCompany] = useState("");
  const [companyTouched, setCompanyTouched] = useState(false);

  const companyInputIsValid = company.trim() !== "";
  const companyInputIsInvalid = companyTouched
    ? !companyInputIsValid
    : props.invalidFieldList && props.invalidFieldList.company;

  const companyInputChangeHandler = (event) => {
    setCompany(event.target.value);
    setCompanyTouched(true);
  };

  const companyInputBlurHandler = (event) => {
    setCompanyTouched(true);
  };


  const [add1, setAdd1] = useState("");
  const [add1Touched, setAdd1Touched] = useState(false);

  const add1InputIsValid = add1.trim() !== "";
  const add1InputIsInvalid = add1Touched
    ? !add1InputIsValid
    : props.invalidFieldList && props.invalidFieldList.add1;

  const add1InputChangeHandler = (event) => {
    setAdd1(event.target.value);
    setAdd1Touched(true);
  };

  const add1InputBlurHandler = (event) => {
    setAdd1Touched(true);
  };

  const [city, setCity] = useState("");
  const [cityTouched, setCityTouched] = useState(false);

  const cityInputIsValid = city.trim() !== "";
  const cityInputIsInvalid = cityTouched
    ? !cityInputIsValid
    : props.invalidFieldList && props.invalidFieldList.city;

  const cityInputChangeHandler = (event) => {
    setCity(event.target.value);
    setCityTouched(true);
  };

  const cityInputBlurHandler = (event) => {
    setCityTouched(true);
  };

  const [state, setState] = useState("");
  const [stateTouched, setStateTouched] = useState(false);

  const stateInputIsValid = state.trim() !== "" && state.trim() !== "-";
  const stateInputIsInvalid = stateTouched
    ? !stateInputIsValid
    : props.invalidFieldList && props.invalidFieldList.state;

  const stateInputChangeHandler = (event) => {
    setState(event.target.value);
    setStateTouched(true);
  };

  const stateInputBlurHandler = (event) => {
    setStateTouched(true);
  };

  const [zip, setZip] = useState("");
  const [zipTouched, setZipTouched] = useState(false);

  const zipInputIsValid = zip.trim() !== "";
  const zipInputIsInvalid = zipTouched
    ? !zipInputIsValid
    : props.invalidFieldList && props.invalidFieldList.zip;

  const zipInputChangeHandler = (event) => {
    setZip(event.target.value);
    setZipTouched(true);
  };

  const zipInputBlurHandler = (event) => {
    setZipTouched(true);
  };

  const [phone, setPhone] = useState("");
  const [phoneTouched, setPhoneTouched] = useState(false);

  const phoneInputIsValid = phone.trim() !== "";
  const phoneInputIsInvalid = phoneTouched
    ? !phoneInputIsValid
    : props.invalidFieldList && props.invalidFieldList.phone;

  const phoneInputChangeHandler = (event) => {
    setPhone(event.target.value);
    setPhoneTouched(true);
  };

  const phoneInputBlurHandler = (event) => {
    setPhoneTouched(true);
  };

  useEffect(() => {
    fetch("/states.json")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setStates(data);
      })
      .catch((error) => {
        console.log(error);
      });
  },[])

  return (
    <div className={styles.addressForm}>
      <div className={styles.add1}>
        <Input
          label={label_company}
          input={{
            id: "company",
            name: "company",
            onChange: companyInputChangeHandler,
            onBlur: companyInputBlurHandler,
            value: company,
            maxlength:"90",
          }}
        />
        {companyInputIsInvalid && (
          <p className={styles.errormsg}>{label_companyRequired}</p>
        )}
      </div>
      <div>
        <Input
          label={label_attention}
          input={{
            id: "attn",
            name: "attn",
            maxlength:"90",
          }}
        />
      </div>
      <div className={styles.add1}>
        <Input
          label={label_address1}
          input={{
            id: "add1",
            name: "add1",
            onChange: add1InputChangeHandler,
            onBlur: add1InputBlurHandler,
            value: add1,
            maxlength:"120",
          }}
        />
        {add1InputIsInvalid && (
          <p className={styles.errormsg}>{label_addressRequired}</p>
        )}
      </div>
      <div>
        <Input
          label={label_address2}
          input={{
            id: "add2",
            name: "add2",
            maxlength:"120",
          }}
        />
      </div>
      <div className={styles.two_col_fields}>
      <div>
        <Input
          label={label_suite}
          input={{
            id: "suite",
            name: "suite",
            maxlength:"50",
          }}
        />
      </div>
      <div>
        <Input
          label={label_building}
          input={{
            id: "bldg",
            name: "bldg",
            maxlength:"128",
          }}
        />
      </div>
      <div>
        <Input
          label={label_room}
          input={{
            id: "room",
            name: "room",
            maxlength:"128",
          }}
        />
      </div>
      <div>
        <Input
          label={label_floor}
          input={{
            id: "floor",
            name: "floor",
            maxlength:"50",
          }}
        />
      </div>
      <div className={styles.add1}>
        <Input
          label={label_cityTown}
          input={{
            id: "city",
            name: "city",
            onChange: cityInputChangeHandler,
            onBlur: cityInputBlurHandler,
            value: city,
            maxlength:"60",
          }}
        />
        {cityInputIsInvalid && (
          <p className={styles.errormsg}>{label_cityTownRequired}</p>
        )}
      </div>
      {stateJSON && Object.keys(stateJSON).length > 1 && (
        <div className={styles.add1}>
          <label htmlFor="state">{label_state}</label>
          <select id="state" name="state" onChange={stateInputChangeHandler} onBlur={stateInputBlurHandler}>
            {Object.keys(stateJSON).map((key, index) => <option value={key}>{stateJSON[key]}</option>)}
          </select>
          {/*
          <Input
            label="State"
            input={{
              id: "state",
              name: "state",
              onChange: stateInputChangeHandler,
              onBlur: stateInputBlurHandler,
              value: state,
            }}
          />*/}
          {stateInputIsInvalid && (
            <p className={styles.errormsg}>{label_stateRequired}</p>
          )}
        </div>
      )}
      </div>
      <div className={styles.add1}>
        <Input
          label={label_zip}
          input={{
            id: "zip",
            name: "zip",
            onChange: zipInputChangeHandler,
            onBlur: zipInputBlurHandler,
            value: zip,
            maxlength:"60",
          }}
        />
        {zipInputIsInvalid && (
          <p className={styles.errormsg}>{label_zipRequired}</p>
        )}
      </div>
      <div className={styles.phone_extn}>
      <div className={styles.add1}>
        <Input
          label={label_phNumber}
          input={{
            id: "phone",
            name: "phone",
            onChange: phoneInputChangeHandler,
            onBlur: phoneInputBlurHandler,
            value: phone,
            maxlength:"30",
          }}
        />
        {phoneInputIsInvalid && (
          <p className={styles.errormsg}>{label_phoneRequired}</p>
        )}
      </div>
      <div>
        <Input
          label={label_phExt}
          input={{
            id: "ext",
            name: "ext",
            maxlength:"10",
          }}
        />
      </div>
      </div>
    </div>
  );
};

export default AddressDetails;
